<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

        <v-dialog v-model="this.$store.getters.messageModal" persistent max-width="500" @keydown.esc="disagreeButton">
            <v-card>
                <v-card-title class="secondary white--text headline justify-center" v-if="$store.getters.messageObject.hasOwnProperty('title')">{{$store.getters.messageObject.title}}</v-card-title>
                <v-card-title class="red white--text headline justify-center" v-if="$store.getters.messageObject.hasOwnProperty('warningTitle')">{{$store.getters.messageObject.warningTitle}}</v-card-title>
                <v-card-text v-if="$store.getters.messageObject.hasOwnProperty('message')">{{$store.getters.messageObject.message}}</v-card-text>
                <v-card-text v-if="$store.getters.messageObject.hasOwnProperty('warningMessage')">{{$store.getters.messageObject.warningMessage}}
                    <v-tooltip bottom>
                        <template slot="activator" slot-scope="{ on }">
                            <v-icon class="right" color="red" v-on="on">info</v-icon>
                        </template>
                        <span>Για μαθήματα που δεν είστε εγγεγραμμένος στο τρέχον εξάμηνο στη Γραμματεία της Σχολής σας, δεν δικαιούστε δωρεάν διανομή συγγραμμάτων</span>
                    </v-tooltip>
                </v-card-text>
                <v-card-text v-if="$store.getters.messageObject.hasOwnProperty('warningList')" v-html="$store.getters.messageObject.warningList"></v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="this.$store.getters.messageObject.disagree" color="primary darken-0" flat @click="disagreeButton" >Άκυρο</v-btn>
                    <v-btn v-if="this.$store.getters.messageObject.close" color="primary darken-0" flat @click="disagreeButton" >Κλείσιμο</v-btn>
                    <v-btn v-if="this.$store.getters.messageObject.agree" color="primary darken-0"  @click="redirectToPendingEvaluation()">Συνέχεια</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
    export default {
        name: "messageComponent",
        data(){
            return{
                dialog: true,
                credits:''
            }
        },
        methods: {
          disagreeButton(){
              this.$store.commit('setMessageModal' ,false);
          },
            redirectToPendingEvaluation(){
                var link = '/public/book/student/evaluation/' + this.$store.getters.login.encryptedId;
                window.open(link, "_blank");
                this.$store.commit('setMessageModal' ,false);            }
        }
    }
</script>

<style scoped>

</style>